/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef } from 'react';
import style from './grid2.module.scss';
import { useNavigate } from 'react-router';
import Skeleton from '@mui/material/Skeleton';
import map from 'lodash-es/map';
import isEmpty from 'lodash-es/isEmpty';
import { GridItem } from 'store/types';
import cx from 'classnames';
import { TransitionGroup } from 'react-transition-group';
import {
  DURATIONS,
  getCurrentPadding,
  MIN_SCREEN_WIDTH,
  MIN_TABLET_WIDTH,
} from 'utils/utils';
import { useGrid } from 'hooks/useGrid';
import { useViewport } from 'contexts/viewportContext';

const DEFAULT_MESH = {
  ' 3': 245,
  ' 4': 200,
};

const TABLET_MESH = {
  ' 3': 195,
};

const MOBILE_MESH = {
  ' 2': 125,
  ' 1': 264,
};

export default function Grid2({
  images,
  shouldImagesScroll,
}: {
  images: GridItem[];
  shouldImagesScroll?: boolean;
}) {
  const navigate = useNavigate();
  const containerRef = useRef<HTMLDivElement>(null);
  const { width } = useViewport();

  const isAdaptiveModeOn = width <= MIN_SCREEN_WIDTH;
  const isMobileAdaptiveModeOn = width <= MIN_TABLET_WIDTH;

  const containerWidth = isAdaptiveModeOn
    ? width - getCurrentPadding(isAdaptiveModeOn, width) * 2
    : containerRef?.current?.getBoundingClientRect().width ||
      width - getCurrentPadding(isAdaptiveModeOn, width) * 2;
  const gap = 20;

  const { items, conteinerHeight } = useGrid({
    mesh: isMobileAdaptiveModeOn
      ? MOBILE_MESH
      : isAdaptiveModeOn
      ? TABLET_MESH
      : DEFAULT_MESH,
    containerWidth,
    gap,
    items: images,
    duration: DURATIONS.GRID_ITEM,
    shouldImagesScroll: shouldImagesScroll,
    constructItem: (item) => {
      const isVertical = item.thumbnailHeight > item.thumbnailWidth;
      const isSquare =
        Math.abs(item.thumbnailHeight - item.thumbnailWidth) < 10;
      const objectFit =
        isVertical || isSquare || item.thumbnailWidth / item.thumbnailHeight > 2
          ? 'contain'
          : 'cover';

      return (
        <>
          <a
            className={style.item}
            id={item.id}
            onClick={(e) => {
              e.preventDefault();

              navigate(`/card/${item.id}`, {
                replace: false,
              });
            }}
            href={`/card/${item.id}`}
          >
            <img
              className={style.image}
              src={item.thumbnail}
              style={{ objectFit }}
            ></img>
          </a>
          {item.customOverlay}
        </>
      );
    },
  });

  useEffect(() => {
    if (containerRef.current && conteinerHeight > 0) {
      containerRef.current.style.height = `${conteinerHeight}px`;
    }
  }, [conteinerHeight]);

  return !isEmpty(images) ? (
    <div
      className={cx(
        style.container,
        'noselect',
        shouldImagesScroll && style['image-scroll']
      )}
      ref={containerRef}
    >
      <TransitionGroup component={null}>{items}</TransitionGroup>
    </div>
  ) : (
    <div className={cx(style.container, 'noselect')} ref={containerRef}>
      <div className={style.sketeton1}>
        {map(Array(3), (v, i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            width={'100%'}
            height={'100%'}
          />
        ))}
      </div>
      <div className={style.sketeton2}>
        {map(Array(4), (v, i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            width={'100%'}
            height={'100%'}
          />
        ))}
      </div>
      <div className={style.sketeton1}>
        {map(Array(3), (v, i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            width={'100%'}
            height={'100%'}
          />
        ))}
      </div>
      <div className={style.sketeton2}>
        {map(Array(4), (v, i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            width={'100%'}
            height={'100%'}
          />
        ))}
      </div>
    </div>
  );
}
